import { Brick, BrickContext, registerBrick } from 'olympe';

type Inputs = [json: string];

type Outputs = [setArray: (array: Array<unknown>) => unknown];

export default class JSONToArray extends Brick {
  update($: BrickContext, [json]: Inputs, [setArray]: Outputs) {
    setArray(JSON.parse(json));
  }
}

registerBrick('018a1d5dd3d865766e11', JSONToArray);
